<template>
  <div>
    <div class="bd-cell-item flex-r-cc">
      <div class="value" v-if="item.type == 0" v-html="item.value"></div>
      <div v-if="item.type == 2">
        <i class="iconfont iconduigou"></i>
      </div>
      <div v-if="item.type == 1">
        <i class="iconfont iconcuowu"></i>
      </div>
    </div>
    <div class="line"></div>
  </div>
</template>
<script>
export default {
  name: 'bd-cell-item',
  props: ['item'],
}
</script>
<style lang="scss" scoped>
.bd-cell-item {
  text-align: center;
  width: 200px;
  height: 60px;
  font-size: 12px;

  &:hover {
    background-color: rgb(243, 243, 243);
  }
  .iconduigou {
    color: #29bdb9;
    font-size: 22px;
  }
  .iconcuowu {
    color: #a6a6a6;
    font-size: 18px;
  }
}
.line {
  width: 150px;
  height: 1px;
  background-color: #f0f7f7;
  margin: auto;
}
@media screen and (max-width: 600px) {
  .bd-cell-item {
    width: initial;
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .bd-cell-item {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tariff/bd-cell/bd-cell-item.vue